{
  "required": "Required",
  "email": {
    "invalid": "Invalid email address",
    "company": "Please use a company email address"
  },
  "phone": {
    "invalid": "Invalid phone number"
  },
  "locale": {
    "invalid": "Enter a valid region format"
  },
  "timezone": {
    "invalid": "Enter a valid time zone"
  },
  "redemption": {
    "amountRequired": "Enter an amount to redeem",
    "acceptTerms": "You must accept the terms and conditions",
    "range": "You can only redeem an amount between {{min}} and {{max}} per request.",
    "balance": "Redemption amount cannot exceed your available balance."
  },
  "text": {
    "tooShort_one": "Must be at least {{count}} character",
    "tooShort_other": "Must be at least {{count}} characters",
    "tooLong_one": "Must be at most {{count}} character",
    "tooLong_other": "Must be at most {{count}} characters"
  },
  "conciergeBooking": {
    "partySizeRequired": "Party size is required",
    "dateRequired": "Date is required",
    "privacyLevelRequired": "Privacy Level is required",
    "eventNameRequired": "Please enter a name for your event",
    "timeRequired": "Time is required",
    "vendorRequired": "Please select or enter a vendor.",
    "vendorManualContactRequired": "Please enter at least a name and one of: website, address, or phone number.",
    "budgetRequired": "Budget is required",
    "eventRequired": "Event is required",
    "paymentCardRequired": "Payment card is required",
    "amountRequired": "Amount is required",
    "amountPositive": "Amount must be a positive number",
    "conciergeEventTypeRequired": "Event Type is required",
    "businessReasonRequired": "Please enter a valid business reason",
    "poOptionRequired": "Please select a purchase order option",
    "poSelectRequired": "Please select a purchase order",
    "poNumberRequired": "Please enter a purchase order number"
  },
  "andeBooking": {
    "leadRequired": "Lead is required",
    "cannotAddAndRemoveShortlist": "Cannot add and remove from shortlist in the same request",
    "shortlistLeadIdRequired": "Lead id is required to remove from shortlist",
    "selectAtLeastOneRoom": "Please select at least one room",
    "newEventDateRequired": "Please choose a date for your event",
    "newEventPartySizeRange": "Please enter between 1 and {{max}} guests"
  },
  "reservationConfirm": {
    "contractFullName": "Please enter your full name: {{expectedName}}",
    "complianceReviewRequired": "Please select whether this reservation requires a compliance review",
    "businessReasonRequired": "Business reason is required",
    "poBusinessReasonRequired": "Please provide a business reason",
    "paymentRequestIdRequired": "Payment request ID is required",
    "idempotencyIdRequired": "Idempotency ID is required",
    "paymentMethodDetailsRequired": "Payment method details are required"
  }
}
